/**
 * 4-zone risk thresholds for ethic survey scores.
 * Reference lines: 3.5 (acceptable), 4.0/4.2 (healthy/strong).
 */
export type RiskLevel = 'strong' | 'healthy' | 'acceptable' | 'at_risk' | 'critical';

export const THRESHOLD_STRONG = 4.2;
export const THRESHOLD_HEALTHY = 3.8;
export const THRESHOLD_ACCEPTABLE = 3.5;
export const THRESHOLD_AT_RISK = 3.3;

export function getRiskLevel(score: number | null | undefined): RiskLevel {
  if (score == null || Number.isNaN(score)) return 'critical';
  if (score >= THRESHOLD_STRONG) return 'strong';
  if (score >= THRESHOLD_HEALTHY) return 'healthy';
  if (score >= THRESHOLD_ACCEPTABLE) return 'acceptable';
  if (score >= THRESHOLD_AT_RISK) return 'at_risk';
  return 'critical';
}

export function getStatusColor(score: number | null | undefined): string {
  const level = getRiskLevel(score);
  switch (level) {
    case 'strong':
      return '#22C55E'; // green
    case 'healthy':
      return '#4ADE80'; // light green
    case 'acceptable':
      return '#F59E0B'; // amber
    case 'at_risk':
      return '#F97316'; // orange
    case 'critical':
    default:
      return '#EF4444'; // red
  }
}

export function getRiskLevelLabel(level: RiskLevel): string {
  switch (level) {
    case 'strong':
      return 'Strong';
    case 'healthy':
      return 'Healthy';
    case 'acceptable':
      return 'Acceptable';
    case 'at_risk':
      return 'At Risk';
    case 'critical':
      return 'Critical';
    default:
      return 'Critical';
  }
}
